export const UserAddItem = "user_add_item";
export const UserEditItem = "user_edit_item";
export const UserAddMemberItem = "user_add_member_item";    
export const UserAddComment = "user_add_comment";
// export const UserAddTag = "user_add_tag";  